import AxiosControl from '../context/axios/AxiosControl'
const Axios = AxiosControl()

export const addChoose = (selection, candidate, type) => async (dispatch) => {
    dispatch({
        type: 'CHOOSE_LOADING'
    })
    try {
        const { data, status } = await Axios.post('/api/client/choose/register', {selection, candidate, type}, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200 || status === 264) {
            dispatch({
                type: 'CHOOSE_ADD_SUCCESS',
                payload: data
            })
            dispatch({
                type: 'CHOOSE_RESET_RESULT'
            })
        }
    } catch (error) {
        dispatch({
            type: 'CHOOSE_NOT_LOADING'
        })
    }
}

export const getReducedChoosesBySelection = (selection) => async (dispatch) => {
    dispatch({
        type: 'CHOOSE_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/client/choose/getreducedbyselection/' + selection, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200 || status === 264) {
            dispatch({
                type: 'CHOOSE_GET_ALL_SUCCESS',
                payload: data.chooses
            })
        }
    } catch (error) {
        dispatch({
            type: 'CHOOSE_NOT_LOADING'
        })
    }
}

export const getChoosesBySelection = (selection) => async (dispatch) => {
    dispatch({
        type: 'CHOOSE_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/client/choose/getbyselection/' + selection, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200 || status === 264) {
            dispatch({
                type: 'CHOOSE_GET_ALL_SUCCESS',
                payload: data.chooses
            })
        }
    } catch (error) {
        dispatch({
            type: 'CHOOSE_NOT_LOADING'
        })
    }
}

export const dimissCandidate = (choose, reason, description) => async (dispatch) => {
    dispatch({
        type: 'CHOOSE_LOADING'
    })
    try {
        const { data, status } = await Axios.put('/api/client/choose/dimissCandidate', {choose, reason, description}, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200) {
            dispatch({
                type: 'CHOOSE_DIMISS_SUCCESS',
                payload: data
            })
            dispatch({
                type: 'CHOOSE_RESET_RESULT'
            })
        } else {
            dispatch({
                type: 'CHOOSE_NOT_LOADING'
            })    
        }
    } catch (error) {
        dispatch({
            type: 'CHOOSE_NOT_LOADING'
        })
    }
}

export const getChoosesByFilter = (selection, client) => async (dispatch) => {
    dispatch({
        type: 'CHOOSE_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/client/choose/getByFilter/' + selection + '/' + client, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200 || status === 264) {
            dispatch({
                type: 'CHOOSE_GET_SUCCESS',
                payload: data.choose
            })
        }
    } catch (error) {
        dispatch({
            type: 'CHOOSE_NOT_LOADING'
        })
    }
}

export const addVideo = (choose, video) => async (dispatch) => {
    dispatch({
        type: 'CHOOSE_LOADING'
    })
    try {
        let videoUrl = ""

        if(video !== null && video !== undefined && video !== '' && typeof video !== 'string'){
            let fileData = new FormData()
            fileData.append('file', video)

            const {data} = await Axios.post('/api/upload/uploaddocument', fileData, {
                headers: {
                    'Content-Type': `multipart/form-data`,
                    auth: sessionStorage.getItem('jwt')
                }
            })
            videoUrl = data
        }else{
            videoUrl = video
        }


        const { data, status } = await Axios.put('/api/client/choose/addVideo', {choose, video: videoUrl}, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200) {
            dispatch({
                type: 'CHOOSE_ADD_VIDEO_SUCCESS',
                payload: data.message
            })
            dispatch({
                type: 'CHOOSE_RESET_RESULT'
            })
        } else {
            dispatch({
                type: 'CHOOSE_NOT_LOADING'
            })    
        }
    } catch (error) {
        dispatch({
            type: 'CHOOSE_NOT_LOADING'
        })
    }
}

export const viewVideo = (choose) => async (dispatch) => {
    dispatch({
        type: 'CHOOSE_LOADING'
    })
    try {
        const { data, status } = await Axios.put('/api/client/choose/viewVideo/' + choose, {}, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200) {
            dispatch({
                type: 'CHOOSE_VIEW_VIDEO_SUCCESS',
                payload: data.message
            })
            dispatch({
                type: 'CHOOSE_RESET_RESULT'
            })
        } else {
            dispatch({
                type: 'CHOOSE_NOT_LOADING'
            })    
        }
    } catch (error) {
        dispatch({
            type: 'CHOOSE_NOT_LOADING'
        })
    }
}

export const changeCandidateStatus = (choose, candidateStatus) => async (dispatch) => {
    dispatch({
        type: 'CHOOSE_LOADING'
    })
    try {
        const { data, status } = await Axios.put('/api/client/choose/changeCandidateStatus', {choose, candidateStatus}, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200) {
            dispatch({
                type: 'CHOOSE_CANDIDATE_STATUS_SUCCESS',
                payload: data.message
            })
            dispatch({
                type: 'CHOOSE_RESET_RESULT'
            })
        } else {
            dispatch({
                type: 'CHOOSE_NOT_LOADING'
            })    
        }
    } catch (error) {
        dispatch({
            type: 'CHOOSE_NOT_LOADING'
        })
    }
}

export const getInterviewsCalendarBySchool = (school) => async (dispatch) => {
    dispatch({
        type: 'CHOOSE_SCHEDULE_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/client/choose/getInterviewsCalendarBySchool/' + school, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200 || status === 264) {
            dispatch({
                type: 'CHOOSE_GET_SCHEDULE_SUCCESS',
                payload: data.schedule
            })
        } else {
            dispatch({
                type: 'CHOOSE_SCHEDULE_NOT_LOADING'
            })
        }
    } catch (error) {
        dispatch({
            type: 'CHOOSE_SCHEDULE_NOT_LOADING'
        })
    }
}

export const getScheduledInterviewsBySchool = (school) => async (dispatch) => {
    dispatch({
        type: 'CHOOSE_SCHEDULE_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/client/choose/getScheduledInterviewsBySchool/' + school, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200 || status === 264) {
            dispatch({
                type: 'CHOOSE_GET_SCHEDULE_SUCCESS',
                payload: data.schedule
            })
        } else {
            dispatch({
                type: 'CHOOSE_SCHEDULE_NOT_LOADING'
            })
        }
    } catch (error) {
        dispatch({
            type: 'CHOOSE_SCHEDULE_NOT_LOADING'
        })
    }
}

export const getScheduledInterviewsQuantityBySchool = (school) => async (dispatch) => {
    dispatch({
        type: 'CHOOSE_SCHEDULE_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/client/choose/getScheduledInterviewsQuantityBySchool/' + school, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200 || status === 264) {
            dispatch({
                type: 'CHOOSE_GET_SCHEDULE_QTY_SUCCESS',
                payload: data.scheduleQty
            })
        } else {
            dispatch({
                type: 'CHOOSE_SCHEDULE_NOT_LOADING'
            })
        }
    } catch (error) {
        dispatch({
            type: 'CHOOSE_SCHEDULE_NOT_LOADING'
        })
    }
}

export const scheduleInterview = (choose, scheduleIndex, dates) => async (dispatch) => {
    dispatch({
        type: 'CHOOSE_LOADING'
    })
    try {
        const { data, status } = await Axios.put('/api/client/choose/scheduleInterview', {choose, scheduleIndex, dates}, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200) {
            dispatch({
                type: 'CHOOSE_SCHEDULE_INTERVIEW_SUCCESS',
                payload: data.message
            })
            dispatch({
                type: 'CHOOSE_RESET_RESULT'
            })
        } else {
            dispatch({
                type: 'CHOOSE_NOT_LOADING'
            })    
        }
    } catch (error) {
        dispatch({
            type: 'CHOOSE_NOT_LOADING'
        })
    }
}

export const getInterviewsCalendarByCandidate = (candidate) => async (dispatch) => {
    dispatch({
        type: 'CHOOSE_SCHEDULE_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/client/choose/getInterviewsCalendarByCandidate/' + candidate, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200 || status === 264) {
            dispatch({
                type: 'CHOOSE_GET_SCHEDULE_SUCCESS',
                payload: data.schedule
            })
        } else {
            dispatch({
                type: 'CHOOSE_SCHEDULE_NOT_LOADING'
            })
        }
    } catch (error) {
        dispatch({
            type: 'CHOOSE_SCHEDULE_NOT_LOADING'
        })
    }
}

export const getScheduledInterviewsByCandidate = (candidate) => async (dispatch) => {
    dispatch({
        type: 'CHOOSE_SCHEDULE_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/client/choose/getScheduledInterviewsByCandidate/' + candidate, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200 || status === 264) {
            dispatch({
                type: 'CHOOSE_GET_SCHEDULE_SUCCESS',
                payload: data.schedule
            })
        } else {
            dispatch({
                type: 'CHOOSE_SCHEDULE_NOT_LOADING'
            })
        }
    } catch (error) {
        dispatch({
            type: 'CHOOSE_SCHEDULE_NOT_LOADING'
        })
    }
}

export const getScheduledInterviewsQuantityByCandidate = (candidate) => async (dispatch) => {
    dispatch({
        type: 'CHOOSE_SCHEDULE_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/client/choose/getScheduledInterviewsQuantityByCandidate/' + candidate, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200 || status === 264) {
            dispatch({
                type: 'CHOOSE_GET_SCHEDULE_QTY_SUCCESS',
                payload: data.scheduleQty
            })
        } else {
            dispatch({
                type: 'CHOOSE_SCHEDULE_NOT_LOADING'
            })
        }
    } catch (error) {
        dispatch({
            type: 'CHOOSE_SCHEDULE_NOT_LOADING'
        })
    }
}

export const setScheduleInterview = (choose, scheduleIndex, date, comment) => async (dispatch) => {
    dispatch({
        type: 'CHOOSE_LOADING'
    })
    try {
        const { data, status } = await Axios.put('/api/client/choose/setScheduleInterview', {choose, scheduleIndex, date, comment}, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200) {
            dispatch({
                type: 'CHOOSE_SCHEDULE_INTERVIEW_SUCCESS',
                payload: data.message
            })
            dispatch({
                type: 'CHOOSE_RESET_RESULT'
            })
        } else {
            dispatch({
                type: 'CHOOSE_NOT_LOADING'
            })    
        }
    } catch (error) {
        dispatch({
            type: 'CHOOSE_NOT_LOADING'
        })
    }
}

export const removeChoose = (choose, haveReturn) => async (dispatch) => {
    try {
        const { data, status } = await Axios.delete('/api/client/choose/remove/' + choose, {
                headers: { auth: sessionStorage.getItem('jwt') },
                params: { haveReturn: haveReturn }
            }
        )
        if (status === 200) {
            dispatch({
                type: 'CHOOSE_REMOVE_RESULT',
                payload: {...data, chooseId: choose}
            })
            dispatch({
                type: 'CHOOSE_RESET_RESULT'
            })
        }
    } catch (error) {
        dispatch({
            type: 'CHOOSE_NOT_LOADING'
        })
    }
}

export const sendOfferLetter = (choose, offerLetter) => async (dispatch) => {
    dispatch({
        type: 'CHOOSE_LOADING'
    })
    try {
        const { data, status } = await Axios.put('/api/client/choose/sendOfferLetter', {choose, offerLetter}, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200) {
            dispatch({
                type: 'CHOOSE_INCORPORATION_DATE_SUCCESS',
                payload: data.message
            })
        } else {
            dispatch({
                type: 'CHOOSE_NOT_LOADING'
            })    
        }
    } catch (error) {
        dispatch({
            type: 'CHOOSE_NOT_LOADING'
        })
    }
}

export const sendOfferLetterResolution = (choose, resolution, comment) => async (dispatch) => {
    dispatch({
        type: 'CHOOSE_LOADING'
    })
    try {
        const { data, status } = await Axios.put('/api/client/choose/setOfferLetterResolution', {choose, resolution, comment}, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200) {
            dispatch({
                type: 'CHOOSE_SET_OFFER_LETTER_RESOLUTION_SUCCESS',
                payload: data.message
            })
        } else {
            dispatch({
                type: 'CHOOSE_NOT_LOADING'
            })    
        }
    } catch (error) {
        dispatch({
            type: 'CHOOSE_NOT_LOADING'
        })
    }
}

export const addIncorporationDate = (choose, date, hour) => async (dispatch) => {
    dispatch({
        type: 'CHOOSE_LOADING'
    })
    try {
        const { data, status } = await Axios.put('/api/client/choose/setIncorporationDate', {choose, date, hour}, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200) {
            dispatch({
                type: 'CHOOSE_OFFER_LETTER_SUCCESS',
                payload: data.message
            })
        } else {
            dispatch({
                type: 'CHOOSE_NOT_LOADING'
            })    
        }
    } catch (error) {
        dispatch({
            type: 'CHOOSE_NOT_LOADING'
        })
    }
}

export const getChoose = (chooseId) => async (dispatch) => {
    dispatch({
        type: 'CHOOSE_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/client/choose/get/' + chooseId, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200 || status === 264) {
            dispatch({
                type: 'CHOOSE_GET_SUCCESS',
                payload: data.choose
            })
        }
    } catch (error) {
        dispatch({
            type: 'CHOOSE_NOT_LOADING'
        })
    }
}

export const addInterviewNote = (choose, interview, note) => async (dispatch) => {
    dispatch({
        type: 'CHOOSE_NOTE_LOADING'
    })
    try {
        const { data, status } = await Axios.post('/api/client/choose/addInterviewNote', {choose, interview, note}, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200 || status === 264) {
            dispatch({
                type: 'CHOOSE_NOTE_ADD_SUCCESS',
                payload: data
            })
            dispatch({
                type: 'CHOOSE_RESET_RESULT'
            })
        }
    } catch (error) {
        dispatch({
            type: 'CHOOSE_NOTE_NOT_LOADING'
        })
    }
}

export const editInterviewNote = (choose, interview, note) => async (dispatch) => {
    dispatch({
        type: 'CHOOSE_NOTE_LOADING'
    })
    try {
        const { data, status } = await Axios.put('/api/client/choose/editInterviewNote', {choose, interview, note}, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200 || status === 264) {
            dispatch({
                type: 'CHOOSE_NOTE_EDIT_SUCCESS',
                payload: data
            })
            dispatch({
                type: 'CHOOSE_RESET_RESULT'
            })
        }
    } catch (error) {
        dispatch({
            type: 'CHOOSE_NOTE_NOT_LOADING'
        })
    }
}

export const deleteInterviewNote = (choose, interview, note) => async (dispatch) => {
    dispatch({
        type: 'CHOOSE_NOTE_LOADING'
    })
    try {
        const { data, status } = await Axios.put('/api/client/choose/deleteInterviewNote', {choose, interview, note}, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200 || status === 264) {
            dispatch({
                type: 'CHOOSE_NOTE_EDIT_SUCCESS',
                payload: data
            })
            dispatch({
                type: 'CHOOSE_RESET_RESULT'
            })
        }
    } catch (error) {
        dispatch({
            type: 'CHOOSE_NOTE_NOT_LOADING'
        })
    }
}

export const deleteMultipleInterviewNotes = (choose, interview, notes) => async (dispatch) => {
    dispatch({
        type: 'CHOOSE_NOTE_LOADING'
    })
    try {
        const { data, status } = await Axios.put('/api/client/choose/deleteMultipleInterviewNotes', {choose, interview, notes}, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200 || status === 264) {
            dispatch({
                type: 'CHOOSE_NOTE_EDIT_SUCCESS',
                payload: data
            })
            dispatch({
                type: 'CHOOSE_RESET_RESULT'
            })
        }
    } catch (error) {
        dispatch({
            type: 'CHOOSE_NOTE_NOT_LOADING'
        })
    }
}

export const getCandidateHistoryBySelection = (selection, candidate) => async (dispatch) => {
    dispatch({
        type: 'CHOOSE_CANDIDATE_HISTORY_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/client/choose/getCandidateHistoryBySelection/' + selection + '/' + candidate, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200) {
            dispatch({
                type: 'CHOOSE_GET_CANDIDATE_HISTORY_SUCCESS',
                payload: data.candidateHistory
            })
        } else {
            dispatch({
                type: 'CHOOSE_CANDIDATE_HISTORY_NOT_LOADING'
            })
        }
    } catch (error) {
        dispatch({
            type: 'CHOOSE_CANDIDATE_HISTORY_NOT_LOADING'
        })
    }
}